import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=51319dc3&scoped=true"
import script from "./joinUs.vue?vue&type=script&lang=js"
export * from "./joinUs.vue?vue&type=script&lang=js"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=51319dc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51319dc3",
  null
  
)

export default component.exports